export default __webpack_public_path__ + "static/media/LOGO_US commercial serv.66a7847c.png";